export enum TPFeatureFlags {
    // added in 24.07
    ComplianceReportIncludeCertifications = 'compliance-report-include-certifications',
    // added in 24.08
    CertificationsAlliedNonClinical = 'certifications-allied-non-clinical',
    //added in 24.11
    ComplianceReportHospitalUnitLink = 'compliance-report-hospital-unit-link',
    //added in 24.13
    ShowRequiredAndCurrentDocumentManualReview = 'show-required-and-current-document-manual-review',
    //added in 24.15
    ClientPortalVisibilityConfiguration = 'client-visibility-configuration',
    //added in 25.01
    IncludeRequirementsFacilityTypes = 'include-requirements-facility-types',
    IncludeSaveFilterGridOption = 'include-save-filter-grid-option',
    //added in 25.02
    IncludeRequirementsSpecialRules = 'include-requirements-special-rules',
    //added in 25.05
    ProcessSpecialRules = 'process-special-rules',
    JobEditWorkModelAndWorkType = 'job-edit-work-model-and-work-type',
    //added in 25.06
    EnableBatchStatusUpdates = 'enable-batch-status-updates',
    ComplianceReportJobsCertification = 'Compliance-report-jobs-certification',
    //addeed in 25.07
    IncludeRequirementsManualReview = 'include-requirements-manual-review'
}
